export var PdfViewerTranslationKey;
(function (PdfViewerTranslationKey) {
    PdfViewerTranslationKey["Close"] = "close";
    PdfViewerTranslationKey["Download"] = "download";
    PdfViewerTranslationKey["RenderError"] = "render-error";
    PdfViewerTranslationKey["RenderErrorWhenOffline"] = "render-error-when-offline";
    PdfViewerTranslationKey["ToggleThumbnails"] = "toggle-thumbnails";
    PdfViewerTranslationKey["SwitchToSinglePageView"] = "switch-to-single-page-view";
    PdfViewerTranslationKey["SwitchToContinuousScrollView"] = "switch-to-continuous-scroll-view";
    PdfViewerTranslationKey["ZoomIn"] = "zoom-in";
    PdfViewerTranslationKey["ZoomOut"] = "zoom-out";
    PdfViewerTranslationKey["SearchComponentNoResults"] = "search-component-no-results";
    PdfViewerTranslationKey["SearchComponentSearchDocument"] = "search-component-search-document";
    PdfViewerTranslationKey["SearchComponentIsUnavailable"] = "search-component-is-unavailable";
})(PdfViewerTranslationKey || (PdfViewerTranslationKey = {}));
export const PDF_VIEWER_DEFAULT_TRANSLATIONS = {
    [PdfViewerTranslationKey.Close]: 'Close',
    [PdfViewerTranslationKey.Download]: 'Download',
    [PdfViewerTranslationKey.RenderError]: 'Something went wrong while loading this document.',
    [PdfViewerTranslationKey.RenderErrorWhenOffline]: 'Sorry, we’re unable to complete your request. Looks like you’re offline.',
    [PdfViewerTranslationKey.ToggleThumbnails]: 'Toggle thumbnails',
    [PdfViewerTranslationKey.SwitchToSinglePageView]: 'Switch to single page view',
    [PdfViewerTranslationKey.SwitchToContinuousScrollView]: 'Switch to continuous scroll view',
    [PdfViewerTranslationKey.ZoomIn]: 'Zoom in',
    [PdfViewerTranslationKey.ZoomOut]: 'Zoom out',
    [PdfViewerTranslationKey.SearchComponentNoResults]: 'No results',
    [PdfViewerTranslationKey.SearchComponentSearchDocument]: 'Search document',
    [PdfViewerTranslationKey.SearchComponentIsUnavailable]: 'Unavailable'
};
//# sourceMappingURL=pdf-viewer-translations.type.js.map